import http from '@/requests/http'
import utilityHelper from '@/helpers/utils'

class SoundFile {
  static all (params) {
    return http.post('sound-files/index', params)
  }
  static async store (data) {
    const formData = new FormData()
    await utilityHelper.buildFormData(formData, data)
    return http.post('sound-files/store', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
  static destroy (params) {
    return http.post('sound-files/destroy', params)
  }
  static play (params) {
    return http.post('sound-files/play', params)
  }
}

export default SoundFile
